var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 25.3646C22.6504 25.3413 22.3504 25.3413 22.0754 25.3646C16.1254 25.178 11.4004 20.628 11.4004 15.028C11.4004 9.3113 16.3504 4.66797 22.5004 4.66797C28.6254 4.66797 33.6004 9.3113 33.6004 15.028C33.5754 20.628 28.8504 25.178 22.9004 25.3646Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0242 9.33203C45.8742 9.33203 49.7742 12.9954 49.7742 17.4987C49.7742 21.9087 46.0242 25.502 41.3492 25.6654C41.1492 25.642 40.9242 25.642 40.6992 25.6654",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4008 33.972C4.35078 37.752 4.35078 43.912 10.4008 47.6687C17.2758 51.962 28.5508 51.962 35.4258 47.6687C41.4758 43.8887 41.4758 37.7287 35.4258 33.972C28.5758 29.702 17.3008 29.702 10.4008 33.972Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8496 46.668C47.6496 46.318 49.3496 45.6413 50.7496 44.638C54.6496 41.908 54.6496 37.4046 50.7496 34.6746C49.3746 33.6946 47.6996 33.0413 45.9246 32.668",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.cd51ceacf005b56db5def70ad9686494.svg";
export { ForwardRef as ReactComponent };